// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Play from '../_raw/ui/icon_play.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Play);
